import React from 'react';
import { TextField, Box, Typography, MenuItem, Button } from '@mui/material';
import modelTasks from '../../constants/modelTasks.json';
import modelFrameworks from '../../constants/modelFrameworks.json';

const NewModelFormFields = ({ form, handleChange, showFileInput = true, width = '50%' }) => {
  return (
    <>
      <Typography variant="h3" fontWeight={700} color="black" mt={4}>
        New Model Info
      </Typography>
      <Typography variant="h6" color="rgb(158, 151, 151)" mt={2}>
        Fill in your model details to import it to the Model Zoo.
      </Typography>

      <Box
        sx={{
        width: width,
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        padding: 2,
        mt: 1,
        }}
      >
        <Typography variant="h7" color="black">
          Model info
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
        <TextField
        required
          label="Model name"
          name="modelName"
          value={form.modelName || ''}
          onChange={handleChange}
          fullWidth
          autoComplete="off"
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
        />
        
        {showFileInput && (
          <TextField
            required
            type="file"
            name="modelFile"
            onChange={handleChange}
            fullWidth
            autoComplete="off"
            inputProps={{ accept: '.pt,.onnx, .pth, .ckpt' }}
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
          />
        )}
        </Box>
        {/* <Typography variant="h7" color="black" mt={2}>
          Description
        </Typography> */}
        <TextField
          required
          label="Describe your model"
          name="description"
          value={form.description || ''}
          onChange={handleChange}
          multiline
          rows={2}
          fullWidth
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
        />
        

        
        <Box sx={{ display: 'flex', gap: 2 }}>
        {/* <Typography variant="h7" color="rgb(0, 0, 0)" mt={2}>
          Model task
        </Typography> */}

        <TextField
          select
          required
          label="Model task"
          name="modelTask"
          value={form.modelTask || ''}
          onChange={handleChange}
          fullWidth
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
        >
        {modelTasks.map((task) => (
            <MenuItem key={task.value} value={task.value}>
              {task.label}
            </MenuItem>
          ))}
        </TextField>

        <TextField
          select
          required
          label="Model Framework"
          name="modelFramework"
          value={form.modelFramework || ''}
          onChange={handleChange}
          fullWidth
          sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
        >
          {modelFrameworks.map((framework) => (
            <MenuItem key={framework.value} value={framework.value}>
              {framework.label}
            </MenuItem>
          ))}
        </TextField>
        </Box>


        <Typography variant="h7" color="black" >
          Test images (1-3 required)
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Button
            variant="outlined"
            component="label"
            sx={{
            borderRadius: '12px',
            textTransform: 'none',
            justifyContent: 'center',
            color: 'rgba(0, 0, 0, 0.67)',
            borderColor: 'rgba(0, 0, 0, 0.23)', // same as TextField default border
            backgroundColor: 'white',
            '&:hover': {
              borderColor: 'black',
              backgroundColor: 'rgba(0,0,0,0.04)',
            },
            padding: '14px 14px',
            fontWeight: 400,
            fontSize: '16px',
          }}
          >
            Upload Images*
            <input
              type="file"
              name="modelTestImages"
              accept=".png,.jpg,.jpeg"
              multiple
              hidden
              required
              onChange={(e) => {
                const newFiles = Array.from(e.target.files);
                const existingFiles = form.modelTestImages || [];
                const merged = [...existingFiles, ...newFiles].slice(0, 3); // enforce max 3

                handleChange({
                  target: {
                    name: "modelTestImages",
                    type: "file-multi",
                    value: merged,
                  }
                });

                // reset input value so selecting the same file twice still triggers onChange
                e.target.value = null;
              }}
            />
          </Button>

          {/* Preview selected filenames */}
          {form.modelTestImages?.length > 0 && (
            <Box sx={{ mt: 1, fontSize: "0.9rem", color: "gray" }}>
              {form.modelTestImages.map((file, idx) => (
                <div key={idx}>{file.name}</div>
              ))}
            </Box>
          )}
        </Box>



        <Typography variant="h7" color="black" mb={1}>
          Training parameters
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            type="number"
            label="Batch size"
            name="training_params.batchSize"
            value={form.training_params.batchSize || ''}
            onChange={handleChange}
            fullWidth
            autoComplete="off"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
          />
          <TextField
            type="number"
            label="Epochs"
            name="training_params.epochs"
            value={form.training_params.epochs || ''}
            onChange={handleChange}
            fullWidth
            autoComplete="off"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
          />
        {/* </Box> */}

        {/* <Typography variant="h7" color="black" mb={1}>
          Image size
        </Typography> */}
        {/* <Box sx={{ display: 'flex', gap: 2 }}> */}
          <TextField
            type ="number"
            label="Image size"
            name="training_params.imgsz"
            value={form.training_params.imgsz || ''}
            onChange={handleChange}
            fullWidth
            autoComplete="off"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
          />
        </Box>

        <Typography variant="h7" color="black" mb={1}>
          Metrics
        </Typography>
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            label="Inference time (ms)"
            name="metrics.inferenceTime"
            value={form.metrics.inferenceTime || ''}
            onChange={handleChange}
            fullWidth
            autoComplete="off"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
          />
          <TextField
            label="mAP"
            name="metrics.mAP"
            value={form.metrics.mAP || ''}
            onChange={handleChange}
            fullWidth
            autoComplete="off"
            sx={{ '& .MuiOutlinedInput-root': { borderRadius: '12px' } }}
          />
        </Box>


        


      </Box>
    </>
  );
};

export default NewModelFormFields;
